import React from 'react';

const s = {
  page:    { maxWidth: '720px', margin: '0 auto', padding: '4rem 1.5rem 6rem' },
  eyebrow: { fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.15em', color: 'var(--blue-soft)', fontWeight: 500, marginBottom: '0.5rem' },
  h1:      { fontFamily: "'Playfair Display', serif", fontSize: 'clamp(2rem, 4vw, 2.8rem)', color: 'var(--ink)', marginBottom: '0.5rem', fontWeight: 700 },
  date:    { fontSize: '0.82rem', color: 'var(--muted)', marginBottom: '2.5rem' },
  h2:      { fontFamily: "'Playfair Display', serif", fontSize: '1.2rem', color: 'var(--ink)', margin: '2rem 0 0.6rem', fontWeight: 700 },
  p:       { fontSize: '0.95rem', color: 'var(--muted)', lineHeight: 1.85, marginBottom: '1rem' },
  ul:      { paddingLeft: '1.4rem', marginBottom: '1rem' },
  li:      { fontSize: '0.95rem', color: 'var(--muted)', lineHeight: 1.85, marginBottom: '0.3rem' },
  link:    { color: 'var(--blue)', textDecoration: 'underline' },
  divider: { border: 'none', borderTop: '1px solid var(--border)', margin: '2.5rem 0' },
};

export default function PrivacyPolicy() {
  return (
    <div style={s.page}>
      <div style={s.eyebrow}>Legal</div>
      <h1 style={s.h1}>Privacy Policy</h1>
      <p style={s.date}>Last updated: April 11, 2026</p>

      <p style={s.p}>
        ArmenianPlace ("we", "us", or "our") is committed to protecting your privacy. This policy explains what information we collect, how we use it, and what rights you have.
      </p>

      <hr style={s.divider} />

      <h2 style={s.h2}>Information we collect</h2>
      <p style={s.p}>When you sign in with Google, we receive:</p>
      <ul style={s.ul}>
        <li style={s.li}>Your name and email address</li>
        <li style={s.li}>Your Google profile photo (if available)</li>
        <li style={s.li}>A unique identifier from Google</li>
      </ul>
      <p style={s.p}>When you submit a suggestion or feedback, we store:</p>
      <ul style={s.ul}>
        <li style={s.li}>The content of your suggestion or feedback</li>
        <li style={s.li}>Your name and email (associated with your account)</li>
        <li style={s.li}>Timestamps of when content was created or updated</li>
        <li style={s.li}>Upvote activity linked to your account</li>
      </ul>

      <h2 style={s.h2}>How we use your information</h2>
      <ul style={s.ul}>
        <li style={s.li}>To authenticate you and maintain your session</li>
        <li style={s.li}>To display your name alongside your contributions</li>
        <li style={s.li}>To allow you to edit or delete your own content</li>
        <li style={s.li}>To send community updates if you subscribe to our newsletter (optional)</li>
      </ul>
      <p style={s.p}>We do not sell your data. We do not use your data for advertising. We do not share your data with third parties except as required to operate the service (Supabase for database and authentication, AWS for hosting).</p>

      <h2 style={s.h2}>Data storage</h2>
      <p style={s.p}>
        Your data is stored securely in Supabase (PostgreSQL), hosted on AWS infrastructure. All data is encrypted in transit via HTTPS.
      </p>

      <h2 style={s.h2}>Your rights</h2>
      <p style={s.p}>You have the right to:</p>
      <ul style={s.ul}>
        <li style={s.li}>Access the data we hold about you</li>
        <li style={s.li}>Delete your suggestions and feedback at any time (directly on the site)</li>
        <li style={s.li}>Request full deletion of your account and all associated data</li>
        <li style={s.li}>Unsubscribe from any emails at any time</li>
      </ul>
      <p style={s.p}>To request account deletion, email us at <a href="mailto:hello@armenianplace.com" style={s.link}>hello@armenianplace.com</a>.</p>

      <h2 style={s.h2}>Cookies</h2>
      <p style={s.p}>
        We use only essential session cookies required for authentication. We do not use tracking, analytics, or advertising cookies.
      </p>

      <h2 style={s.h2}>Changes to this policy</h2>
      <p style={s.p}>
        If we make significant changes, we will update the date at the top of this page. Continued use of the site after changes constitutes acceptance.
      </p>

      <h2 style={s.h2}>Contact</h2>
      <p style={s.p}>
        Questions? Email <a href="mailto:hello@armenianplace.com" style={s.link}>hello@armenianplace.com</a>
      </p>
    </div>
  );
}